export default function ContactMap() {
  const query = "Cetiber Sistemas de Fixação, Via Central de Milheiros 584, 4475-330 Milheirós";
  return (
    <section className="bg-[#f5f5f5] pb-20 md:pb-28" data-testid="contact-map-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="overline mb-4">Como chegar</div>
        <h3 className="font-display font-bold uppercase text-3xl md:text-4xl text-[#0d4c7d] tracking-tight mb-8">
          Visite-nos em Milheirós · Maia
        </h3>
        <div className="relative aspect-[16/9] w-full bg-black border border-[#e4e4e7]">
          <iframe
            title="Mapa CETIBER"
            src={`https://www.google.com/maps?q=${encodeURIComponent(query)}&output=embed`}
            className="w-full h-full"
            style={{ border: 0 }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
}
